import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import cohort from '@uswitch/koa-chansey/cohort';
import { useExperiences } from '@uswitch/ev-utils/context/selectors';
export var queryList = function queryList() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var _url$split = url.split('?'),
      _url$split2 = _slicedToArray(_url$split, 2),
      _url$split2$ = _url$split2[1],
      search = _url$split2$ === void 0 ? '' : _url$split2$;

  return search.split('&').reduce(function (acc, it) {
    var _it$split = it.split('='),
        _it$split2 = _slicedToArray(_it$split, 2),
        param = _it$split2[0],
        _it$split2$ = _it$split2[1],
        value = _it$split2$ === void 0 ? '' : _it$split2$;

    return acc.concat({
      param: param,
      value: value
    });
  }, []);
};
export var appendQuery = function appendQuery() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!url.length) return '';

  var _url$split3 = url.split('?'),
      _url$split4 = _slicedToArray(_url$split3, 2),
      domain = _url$split4[0],
      _url$split4$ = _url$split4[1],
      search = _url$split4$ === void 0 ? '' : _url$split4$;

  if (!search.length) return '';
  var paramsObj = search.split('&').reduce(function (acc, it) {
    var _it$split3 = it.split('='),
        _it$split4 = _slicedToArray(_it$split3, 2),
        param = _it$split4[0],
        _it$split4$ = _it$split4[1],
        value = _it$split4$ === void 0 ? '' : _it$split4$;

    if (!param) return acc;
    return _objectSpread(_defineProperty({}, param, value), acc);
  }, query || {});
  var paramsString = Object.entries(paramsObj).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        param = _ref2[0],
        value = _ref2[1];

    return "".concat(param, "=").concat(value);
  }).join('&');
  return paramsString.length ? "".concat(domain, "?").concat(paramsString) : domain;
};
export var withTrailingSlash = function withTrailingSlash(s) {
  return s.replace(/\/?$/, '/');
};
export var withoutTrailingSlash = function withoutTrailingSlash(s) {
  return s.replace(/\/?$/, '');
};
export var pageForUrlEntity = function pageForUrlEntity(urlEntity, experiences) {
  var _ref3 = urlEntity.fields ? urlEntity.fields : urlEntity,
      link = _ref3.link,
      _ref3$variants = _ref3.variants,
      variants = _ref3$variants === void 0 ? [] : _ref3$variants,
      variantFlag = _ref3.variantFlag;

  var index = cohort({
    experiences: experiences
  }, variantFlag, null);
  var page = index !== null && variants.length > index || !link ? variants[index || 0] : link;
  return page;
};
export var usePageForUrlEntity = function usePageForUrlEntity(urlEntity) {
  return pageForUrlEntity(urlEntity, useExperiences());
};
//# sourceMappingURL=url.js.map